'use client';
import React, { useEffect } from 'react';
import { InactiveColor, Size, StatusBar } from '../StatusBar/StatusBar';
export const getActiveThreshold = (thresholds, occupancyData, includeNested = false) => {
    const unitsRemaining = includeNested
        ? occupancyData.totalUnitsRemaining
        : occupancyData.physicalUnitsRemaining;
    const availabilityPercentage = includeNested
        ? 100 - occupancyData.totalOccupancy
        : 100 - occupancyData.physicalOccupancy;
    return thresholds.find((threshold) => {
        if ('maxPercentage' in threshold) {
            return availabilityPercentage <= threshold.maxPercentage;
        }
        return unitsRemaining <= threshold.maxUnits;
    });
};
export const getStatusBarData = (occupancyData, threshold, includeNested = false) => {
    var _a;
    const unitsRemaining = includeNested
        ? occupancyData.totalUnitsRemaining
        : occupancyData.physicalUnitsRemaining;
    const availabilityPercentage = includeNested
        ? 100 - occupancyData.totalOccupancy
        : 100 - occupancyData.physicalOccupancy;
    if (!threshold) {
        return {
            availabilityLabel: undefined,
            activeColor: undefined,
            value: availabilityPercentage,
        };
    }
    const value = threshold.percentage || availabilityPercentage;
    return {
        availabilityLabel: ((_a = threshold.getLabel) === null || _a === void 0 ? void 0 : _a.call(threshold, 'maxPercentage' in threshold ? availabilityPercentage : unitsRemaining)) ||
            threshold.label ||
            undefined,
        activeColor: threshold.color,
        value,
    };
};
const AvailabilityIndicator = ({ occupancyData, includeNested = false, size = Size.small, thresholds, labelCallback, }) => {
    const segments = 10;
    const activeThreshold = getActiveThreshold(thresholds, occupancyData, includeNested);
    const { availabilityLabel, activeColor, value } = getStatusBarData(occupancyData, activeThreshold, includeNested);
    useEffect(() => {
        if (availabilityLabel && labelCallback) {
            labelCallback(availabilityLabel);
        }
    }, [availabilityLabel, labelCallback]);
    return (<StatusBar segments={segments} value={value} activeColor={activeColor} disabledColor={InactiveColor.grey} size={size} label={availabilityLabel}/>);
};
export default AvailabilityIndicator;
